import React, { Component, Fragment, useState, useRef, useEffect } from 'react';
import { Formik, Form, Field, FieldArray } from 'formik';
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import { Query, Mutation } from 'react-apollo';
import { useQuery, useMutation } from 'react-apollo-hooks';
import gql from 'graphql-tag';
import classNames from 'classnames';
import CreatableSelect from 'react-select/lib/Creatable';
import Textarea from 'react-autosize-textarea';

import useBodyScrollLock from '../../hooks/useBodyScrollLock';
import { ACTS_QUERY } from '../../routes/acts';

const ADD_ACT_SEARCH_MUTATION = gql`
  mutation addActSearch($actName: String!, $search: ActSearchInput) {
    addActSearch(actName: $actName, search: $search)
  }
`;

const AddActModal = ({ act = {}, initialValues = {}, closeModal }) => {
  const scrollable = useRef();
  useBodyScrollLock(scrollable);

  // Available acts
  const { loading, error, data, refetch } = useQuery(ACTS_QUERY);

  const [
    addActSearch,
    { error: addActSearchError, loading: addActSearchLoading }
  ] = useMutation(ADD_ACT_SEARCH_MUTATION);

  if (loading) {
    return 'Loading...';
  }

  if (error || addActSearchError) {
    return `Error! ${error.message || addActSearchError.message}`;
  }

  return (
    <Fragment>
      <div className="modal-header">
        <div className="modal-header-title">Lisää Tunnistus: {act.name}</div>
        <div className="modal-header-close" onClick={closeModal}>
          Sulje
        </div>
      </div>
      <Formik
        initialValues={{
          name: '',
          lang: 'finnish',
          concepts: [
            {
              index: 0,
              json: ''
            }
          ]
        }}
        onSubmit={async (payload, { setSubmitting }) => {
          const { name, lang } = payload;

          setSubmitting(true);

          const concepts = payload.concepts.map(({ index, json }) => {
            try {
              const parsed = JSON.parse(json);

              return { index, json };
            } catch (e) {
              console.log(e);
              return {};
            }
          });

          await addActSearch({
            variables: {
              actName: act.name,
              search: {
                name,
                lang,
                concepts
              }
            },
            refetchQueries: () => [{ query: ACTS_QUERY }],
            awaitRefetchQueries: true
          });

          setSubmitting(false);

          closeModal();
        }}
        render={({
          values,
          handleSubmit,
          setFieldTouched,
          setFieldValue,
          isSubmitting
        }) => (
          <Fragment>
            <div className="modal-content" ref={scrollable}>
              <div className="modal-content-form">
                <Form>
                  <div className="modal-content-form-header">Nimi</div>
                  <div className="add-act-search-concepts">
                    <Field
                      name="name"
                      render={({ field, form: { isSubmitting } }) => (
                        <input type="text" {...field} disabled={isSubmitting} />
                      )}
                    />
                  </div>
                  <div className="modal-content-form-header">Säännöt</div>
                  <FieldArray
                    name="concepts"
                    render={arrayHelpers => (
                      <div className="add-act-search-concepts">
                        {values.concepts &&
                          values.concepts.map((concept, i) => (
                            <div
                              key={concept.index}
                              className="add-act-search-concept"
                            >
                              <div className="add-act-search-concept-index">
                                {concept.index}
                              </div>
                              <div className="add-act-search-concept-text">
                                <Field
                                  name={`concepts[${concept.index}].json`}
                                  render={({
                                    field,
                                    form: { isSubmitting }
                                  }) => (
                                    <Textarea
                                      {...field}
                                      rows={1}
                                      disabled={isSubmitting}
                                    />
                                  )}
                                />
                              </div>
                              <div className="add-act-search-concept-remove">
                                {concept.index > 0 && (
                                  <button
                                    type="button"
                                    className="add-act-search-concept-remove-button"
                                    onClick={() =>
                                      arrayHelpers.remove(concept.index)
                                    } // remove a friend from the list
                                  >
                                    x
                                  </button>
                                )}
                              </div>
                              {concept.index === values.concepts.length - 1 && (
                                <div className="add-qa-question-add">
                                  <button
                                    type="button"
                                    className="add-qa-question-add-button"
                                    onClick={() =>
                                      arrayHelpers.push({
                                        index: values.concepts.length,
                                        json: ''
                                      })
                                    } // insert an empty string at a position
                                  >
                                    + Lisää
                                  </button>
                                </div>
                              )}
                            </div>
                          ))}
                      </div>
                    )}
                  />
                </Form>
              </div>
            </div>
            <div className="modal-footer">
              {isSubmitting && 'Tallennetaan...'}
              {!isSubmitting && (
                <button
                  className="modal-footer-submit-button"
                  type="submit"
                  onClick={handleSubmit}
                >
                  Submit
                </button>
              )}
            </div>
          </Fragment>
        )}
      />
    </Fragment>
  );
};

export default AddActModal;
